const MuiStep = {
  horizontal: {
    paddingLeft: 15,
    paddingRight: 15,
    '&:first-child': {
      paddingLeft: 0
    },
    '&:last-child': {
      paddingRight: 0
    }
  }
};
export default MuiStep;